import {Plan} from '@rechargeapps/storefront-client';

/**
 * Returns the frequency of the given plan's order interval.
 * If the order interval frequency is not specified, it defaults to 1.
 *
 * @param plan - The plan object.
 * @returns The frequency of the order interval.
 */
export function intervalFrequency(plan: Plan): number {
  return plan.subscription_preferences.order_interval_frequency ?? 1;
}

/**
 * Returns the interval unit of a given plan.
 * @param plan - The plan object.
 * @returns The interval unit of the plan, or an empty string if it is not defined.
 */
export function intervalUnit(plan: Plan): string {
  return plan.subscription_preferences.interval_unit ?? '';
}

/**
 * Calculates the discount percentage for a given plan.
 * @param plan - The plan object.
 * @returns The discount percentage as a decimal number.
 */
export function discountPercentage(plan: Plan): number {
  return parseFloat(plan.discount_amount ?? '100') / 100;
}
